var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.467 1.02a1.1 1.1 0 0 1 1.866 1.165l-5.5 8.8a1.1 1.1 0 0 1-1.71.195l-3.3-3.3a1.1 1.1 0 0 1 1.555-1.556L4.7 8.646 9.467 1.02Z"
  })));
};
export { SvgTick as ReactComponent };
export default __webpack_public_path__ + "1bb836d0a7565b5cc74ed8403b1b44ae.svg";